import { objectKeys, objectValues } from 'core/utils';
import { arrayToEnum } from '../utils';
import type { Enum } from './types';
import type { TreeGrid } from '../types';

export const convertEnum = (
  type?: TreeGrid.ColumnType,
  _enum?: Enum['Enum'],
  enumMenu?: string,
) => {
  if (type !== 'Enum') return {};

  if (enumMenu) {
    return {
      EnumMenu: enumMenu,
    };
  }

  if (_enum) {
    if (Array.isArray(_enum)) {
      return {
        Enum: arrayToEnum(_enum),
      };
    }

    return {
      EnumKeys: arrayToEnum(objectValues(_enum)),
      Enum: arrayToEnum(objectKeys(_enum)),
    };
  }

  throw new Error('Provide Enum value');
};
